import { Lesson } from '@shared/types';
import styles from './styles.module.scss';
import { PublicCourse } from '@cademy-package/sdk-component-types';
import CircleMinusRegularIcon from '../../../components/Icons/CircleMinusRegularIcon';
import CirclePlusRegularIcon from '../../../components/Icons/CirclePlusRegularIcon';
import { useMemo } from 'react';

export const CourseContentSection = ({
    course,
    lessons,
}: {
    course: PublicCourse;
    lessons: Array<Lesson>;
}) => {
    if (course.type !== 'blended' && course.type !== 'on-demand') {
        return null;
    }

    if (!lessons.length || !course.sections?.length) return null;

    return (
        <section className={styles.contents_section}>
            <h2 className={styles.section_heading}>{course.keyword || 'Course'} Content</h2>
            <div className={styles.course_summary}>
                <span>{course.sections.length} sections</span>
                <span>•</span>
                <span>{lessons.length} lessons</span>
            </div>
            <div className={styles.sections_list}>
                {course.sections.map((section, index) => {
                    const sectionLessons = section.contents
                        .filter(
                            ({ type, ref }) =>
                                type === 'lesson' && lessons.some((lesson) => lesson._id === ref)
                        )
                        .map(({ ref }) => {
                            const lesson = lessons.find((lesson) => lesson._id === ref);
                            return lesson;
                        })
                        .filter((lesson): lesson is Lesson => lesson !== undefined);

                    return (
                        <details
                            open={true}
                            key={`${section.name}-${index}`}
                            className={styles.section_details}
                        >
                            <summary>
                                <CirclePlusRegularIcon className={styles.faqIconPlus} />
                                <CircleMinusRegularIcon className={styles.faqIconMinus} />
                                <div className={styles.section_header}>
                                    <span className={styles.section_name}>
                                        {course.sections && course.sections?.length === 1
                                            ? `Contents`
                                            : `${section.name}`}
                                    </span>
                                    <span className={styles.lesson_count}>
                                        {sectionLessons.length} lessons
                                    </span>
                                </div>
                            </summary>
                            <ol className={styles.lessons_list}>
                                {sectionLessons.map((lesson, lessonIndex) => (
                                    <li key={lesson._id} className={styles.lesson_item}>
                                        <span className={styles.lesson_number}>
                                            {lessonIndex + 1}
                                        </span>
                                        <span className={styles.lesson_name}>{lesson.name}</span>
                                    </li>
                                ))}
                            </ol>
                        </details>
                    );
                })}
            </div>
        </section>
    );
};

export default CourseContentSection;
